import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropDownComponent } from './components/drop-down/drop-down.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [DropDownComponent],
  exports: [DropDownComponent]
})
export class DropDownModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/drop-down/drop-down.module.ts